import { ReactElement } from "react";
import { ComponentEvent } from "@/graphHandling/graphTypes";
import { Button, Tooltip } from "@mui/material";
import UndoIcon from "@mui/icons-material/Undo";
import common from "@/i18n/definitions/common";
import { useIntl } from "react-intl";

export interface IUndoProps {
  isHidden?: boolean;
  listOfCellIds?: Array<string>;
  title: string;
}

interface IUndoPropsWithEvents extends IUndoProps {
  onClick: ComponentEvent;
}

/**
 * Undo-komponentin toteutus.
 * @param props
 * @returns
 */
export const Undo = (props: IUndoPropsWithEvents): null | ReactElement => {
  const { formatMessage } = useIntl();
  return props.isHidden ? null : (
    <Tooltip title={props.title}>
      <Button
        component="span"
        color="primary"
        endIcon={<UndoIcon />}
        onClick={(e: any) => {
          e.stopPropagation();
          return props.onClick({
            changeProps: {
              listOfCellIds: props.listOfCellIds
            },
            mouseEvent: e
          });
        }}
        size="small">
        {formatMessage(common.undo)}
      </Button>
    </Tooltip>
  );
};
